<template lang="pug">
  div
    Breadcrumbs(:breadcrumbs="breadcrumbs",
              :truncateTo="25",
              v-if="!isScrolledDown")
    h1 {{ 'shifts' | translate }}
</template>

<script>
import Breadcrumbs from "~/components/Breadcrumbs"
import { mapFields } from "vuex-map-fields"
import { mapGetters } from "vuex"
export default {
  components: {
    Breadcrumbs
  },
  computed: {
    ...mapFields('header',['isScrolledDown']),
    ...mapFields('job',['job']),
    ...mapFields('jobRevision', ['jobRevision', 'jobRevisionBreadcrumbs']),
    ...mapGetters('jobRevision', ['getRevisionBreadcrumb']),
    breadcrumbs() {
      if (this.jobRevision) return [
        ...this.jobRevisionBreadcrumbs,
        { text: this.translate('shifts') },
      ]
      return []
    }
  }
};
</script>
